import {
    buildActionCreators,
    makeActionTypes,
    namedParameters,
} from '/b2b/common/helpers/ReduxHelpers';

import { DOMAIN } from './Palette.constants';

export const events = {
    fieldChange: namedParameters('field', 'value', 'oldValue'),
};

export const types = makeActionTypes(Object.keys(events), DOMAIN);

export default buildActionCreators(events, types);
